<template>
  <v-container fluid>
    <v-row>
      <!-- filter -->
      <v-col cols="12" md="3">
        <wapi-panel :title="'Фильтр'">
          <template v-slot:content>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-select
                v-model="userId"
                :items="users"
                item-text="name"
                item-value="id"
                label="Клиент"
                :rules="[rules.required]"
                dense
                outlined
              ></v-select>
            </v-form>
          </template>
        </wapi-panel>
      </v-col>
      <!-- query props -->
      <v-col cols="12" md="9">
        <wapi-panel :title="'Настройки запроса'" :spacing="false">
          <template v-slot:content>
            <!-- map -->
            <v-row>
              <v-col class="py-0">
                <div style="height: 415px;">
                  <l-map
                    ref="map"
                    :zoom="13"
                    :center="center"
                    @click="click"
                    :class="'wapi_map__map'"
                  >
                    <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
                    <l-geo-json ref="geoJsonLayer" :geojson="geojson" :options="geoJsonOptions" />
                    <l-marker :lat-lng="[latitude, longitude]"></l-marker>
                  </l-map>
                </div>
              </v-col>
            </v-row>
            <!-- params -->
            <v-row class="pl-4">
              <!-- latlng -->
              <v-col cols="3">
                <v-text-field v-model="latitude" label="Широта" type="number" outlined dense></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="longitude" label="Долгота" type="number" outlined dense></v-text-field>
              </v-col>
              <!-- buttons -->
              <v-col cols="3">
                <v-btn class="ma-0" color="primary" @click="loadResult()" dense>Выполнить запрос</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="9">
                <v-container fluid>
                  <v-textarea
                    clearable
                    clear-icon="mdi-close-circle"
                    label="Text"
                    v-model="textPoints"
                  ></v-textarea>
                </v-container>
              </v-col>
              <v-col>
                <v-btn class="ma-0" color="primary" @click="report" dense>Отчет</v-btn>
              </v-col>
            </v-row>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
    <v-row class="ml-2">
      <v-col>
        <wapi-panel :title="'Результаты'" :spacing="false" v-if="forecast.parameters">
          <template v-slot:content>
            <v-tabs background-color="primary" dark>
              <v-tab>Таблица</v-tab>
              <v-tab>JSON</v-tab>
              <v-tab-item>
                <forecast-tabs :model="forecast"></forecast-tabs>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <json-viewer :value="json" copyable expanded :expand-depth="5" boxed sort></json-viewer>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../../models/contract/WapiContract";
import rules from "../../models/helpers/rules";
import settings from "../../settings.json";
import { datePickerDate } from "../../helpers/common";
import WapiPanel from "../../components/WapiPanel";
import ForecastTabs from "../../components/ForecastTabs.vue";
import WapiForecastMessageViewModel from "../../models/viewmodels/WapiForecastMessageViewModel";
import Papa from "papaparse";

export default {
  name: "ForecastPointsView",
  title: "Прогноз в точке",
  components: {
    WapiPanel,
    ForecastTabs
  },
  async mounted() {
    await this.$store.dispatch("FETCH_USERS");
    this.users = this.$store.getters.USERS;
  },
  data: function() {
    return {
      markerLatLng: settings.center,
      dateStart: datePickerDate(),
      dateEnd: datePickerDate(),
      menuDateStart: false,
      menuDateEnd: false,
      contractModel: new WapiContract(),
      textPoints: `1. Балашиха;55,797007;37,938118
2. Видное (Ленинский);55,556869;37,708787
3. Волоколамск;56,016667;35,933333
4. Воскресенск;55,303611;38,6575
5. Дмитров;56,35;37,56667
6. Домодедово;55,4;37,9`,
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      },
      users: [],
      userId: "",
      latitude: settings.center[0],
      longitude: settings.center[1],
      geojson: null,
      valid: true,
      rules: rules,
      center: settings.center,
      result: [],
      lastTime: null,
      json: {},
      forecast: []
    };
  },
  methods: {
    async report() {
      const result = Papa.parse(this.textPoints, { delimiter: ";" });
      const points = result.data.map(x => {
        return {
          name: x[0],
          latitude: parseFloat(x[1].replace(/,/, ".")),
          longitude: parseFloat(x[2].replace(/,/, "."))
        };
      });

      const request = {
        userId: this.userId,
        points: points
      };

      await this.$store.dispatch("SET_LOADING", true);

      await this.$store.dispatch("FORECAST_POINTS_REPORT", request);

      await this.$store.dispatch("SET_LOADING", false);
    },
    async loadResult() {
      if (!this.$refs.form.validate()) return;
      const params = {
        userId: this.userId,
        latitude: this.latitude,
        longitude: this.longitude
      };

      await this.$store.dispatch("SET_LOADING", true);
      this.result = await this.$store.dispatch(
        "FETCH_FORECAST_LAST_BY_POINT_USER",
        params
      );
      this.json = this.result;

      if (!this.json) {
        await this.$store.dispatch(
          "PUSH_ERROR_MESSAGE",
          "Нет данных для отображения"
        );
        await this.$store.dispatch("SET_LOADING", false);
        return;
      }

      this.forecast = new WapiForecastMessageViewModel().map(this.result);
      await this.$store.dispatch("SET_LOADING", false);
    },
    async loadLastTime() {
      this.lastTime = await this.$store.dispatch("FETCH_FORECAST_LAST_TIME");
    },
    click(event) {
      this.latitude = event.latlng.lat;
      this.longitude = event.latlng.lng;
      this.markerLatLng = [this.latitude, this.longitude];
    }
  }
};
</script>